<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>
							<div
								class="modal-header row"
								style="justify-content: flex-end;"
							>
								<div class="col">
									<button
										type="button"
										class="close"
										@click="$emit('closeModal')"
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
							</div>

							<div class="modal-body">
								<h2 class="title">Add Bulk Event</h2>
								<form>
									<h4>
										Please Download the Excel Template for
										Inputting Bulk Calendar Event Date
									</h4>

									<a
										class="btn btn-success"
										download
										style="color:white"
										href="/template/Holiday Template.xls"
									>
										<i class="fas fa-file-excel mr-2"></i>
										Download Template Excel
									</a>
									<hr class="mt-3 mb-3" />

									<h4>Input File Here</h4>
									<div class="row row-space">
										<div class="col-12">
											<input
												type="file"
												class="form-control border border-secondary pb-2"
												@change="validateSize"
											/>
										</div>
									</div>
									<div class="row">
										<div
											class="col mt-5"
											style="text-align: center"
										>
											<button
												type="button"
												class="btn btn-outline-danger"
												style="font-size:140%"
												@click="$emit('closeModal')"
											>
												Cancel
											</button>
											<button
												type="button"
												class="btn btn-primary ml-5"
												style="font-size:150%"
												@click="submitForm()"
											>
												Add
											</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
			</div>
		</div>
	</transition>
</template>

<script>
import MultiSelect from "vue-multiselect";
import flatPickr from "vue-flatpickr-component";
const XLSX = require('xlsx')
import moment from 'moment';

export default {
	data() {
		return {
			file: null,
		};
	},
	components: {
		MultiSelect,
		flatPickr,
	},
	mounted() {},
	watch: {

	},
	methods: {
		validateSize : function(data){
            var file = data.target.files[0];
            if(file.type != "text/csv" && file.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type != 'application/vnd.ms-excel')
            {
                this.fileError = "Unsupported File Type! Only accepts CSV or XLSX Files";
                return false;
            }

            var size  = file.size / 1024 / 1024;

            if(size > 4)
            {
                this.fileError = "File size is too big";
                return false;
            }

            this.fileError = "";
            this.file = file;
            return true;
        },
		validateForm() {
			var valid = true;
			var error = [];

			if(!this.file){
				error.push('File Not Uploaded. Please Try Again.')
				valid = false
			}
				

			if (!valid) this.$emit("triggerAlert", !valid, error);
			else return valid;
		},
		readExcel (fileToBeRead) {
			console.log(fileToBeRead)
			var fileReader = new FileReader();
			let vm = this;
			fileReader.onload = function (e) {
				console.log(e)
				var filename = fileToBeRead.name;
				// pre-process data
				var binary = "";
				var bytes = new Uint8Array(e.target.result);
				// console.log(bytes)
				var length = bytes.byteLength;
				for (var i = 0; i < length; i++) {
					// console.log(bytes[i])
					binary += String.fromCharCode(bytes[i]);
				}
				// console.log(binary)
				// call 'xlsx' to read the file
				var oFile = XLSX.read(binary, {type: 'binary' , header : 1});
				

				// console.log(oFile)
				const sheetData = oFile.Sheets[oFile.SheetNames[0]]
				let data = XLSX.utils.sheet_to_json(sheetData)

				console.log(data)
				

				for(var i = 0 ; i < data.length ; i++) {
					let curData = data[i]
					curData['From'] = new moment(vm.ExcelDateToJSDate(curData['From'])).format('Y-MM-DD')
					if(!curData['To']) {
						curData['To'] = curData['From']
					}
					else {
						curData['To'] = new moment(vm.ExcelDateToJSDate(curData['To'])).format('Y-MM-DD')
					}

					let form = {
						start : curData['From'],
						end : curData['To'],
						holiday : curData['Holiday'] == 'Y' ? 1 : 0,
						note : curData['Note']
					}

					vm.$http
					.post("/api/setting/calendar", form)
					.then((resp) => {
						// this.triggerAlert(true , ['Succesfully Saved Calendar Event'])
						vm.$emit("onSuccess");
						vm.$emit("closeModal");
					})
					.catch((err) => {
						console.log(err);
					});


				}

			};
			fileReader.readAsArrayBuffer(fileToBeRead);
		},
		ExcelDateToJSDate(serial) {
			var utc_days  = Math.floor(serial - 25569);
			var utc_value = utc_days * 86400;                                        
			var date_info = new Date(utc_value * 1000);

			var fractional_day = serial - Math.floor(serial) + 0.0000001;

			var total_seconds = Math.floor(86400 * fractional_day);

			var seconds = total_seconds % 60;

			total_seconds -= seconds;

			var hours = Math.floor(total_seconds / (60 * 60));
			var minutes = Math.floor(total_seconds / 60) % 60;

			return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
		},
		async submitForm() {
			let vm = this;
			if (vm.validateForm()) {
				let dataCalendar = await this.readExcel(this.file)
				
			}
		},
	},
};

function isRTL() {
	return (
		document.documentElement.getAttribute("dir") === "rtl" ||
		document.body.getAttribute("dir") === "rtl"
	);
}
</script>

<style scoped>
.modal-mask {
	position: fixed;
	z-index: 1020;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.modal-container {
	width: 100%;
	margin: 0px auto;
	padding: 20px 30px;
	background-color: #fff;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
	margin-top: 0;
	color: #42b983;
}

.modal-body {
	margin: 20px 0;
}

.modal-default-button {
	float: right;
}

/*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}

/* MODAL STARTS */
.modal-body {
	margin: 0;
}

.modal-body .moduleLine {
	margin-bottom: 0vh;
}

.modal-body .moduleLine a {
	text-decoration: none;
}

.modal-body .moduleLine .moduleBox:hover {
	background-color: #e0e0e0;
	transition: background-color 0.7s ease;
	color: #212121;
	transition: color 0.7s ease;
}

.modal-body .moduleLine .moduleBox {
	border: 1px solid #bdbdbd;
	border-radius: 20px;
	padding: 20px 0;
	color: black;
	margin-bottom: 3vh;
}

.modal-body .moduleLine .moduleBox i {
	font-size: 5vh;
}

h3.modalHeadline {
	margin: 0 0 20px 0;
	font-weight: bold;
	text-align: center;
}
/* MODAL ENDS */

/* ==========================================================================
  #FORM made by Colorlib (https://colorlib.com)
  ========================================================================== */
input {
	outline: none;
	margin: 0;
	border: none;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	width: 100%;
	font-size: 14px;
	font-family: inherit;
}

.input--style-4 {
	line-height: 50px;
	background: #fafafa;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	padding: 0 20px;
	font-size: 16px;
	color: #666;
	-webkit-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
	/* WebKit, Blink, Edge */
	color: #666;
}

.input--style-4:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #666;
	opacity: 1;
}

.input--style-4::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #666;
	opacity: 1;
}

.input--style-4:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	color: #666;
}

.input--style-4:-ms-input-placeholder {
	/* Microsoft Edge */
	color: #666;
}

.label {
	font-size: 16px;
	color: #555;
	text-transform: capitalize;
	display: block;
	margin-bottom: 5px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 30px;
	cursor: pointer;
	font-size: 16px;
	color: #666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
	background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
	display: block;
}

.radio-container .checkmark:after {
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 12px;
	height: 12px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	background: #57b846;
}

.checkmark {
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #e5e5e5;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

.input-group {
	position: relative;
	/* margin-bottom: 22px; */
	padding: 20px;
}

.input-group-icon {
	position: relative;
}

.input-icon {
	position: absolute;
	font-size: 18px;
	color: #999;
	right: 18px;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	cursor: pointer;
}

/* ==========================================================================
     #TITLE made by Colorlib (https://colorlib.com)
     ========================================================================== */
.title {
	font-size: 40px;
	color: #525252;
	margin-bottom: 40px;
	text-align: center;
}

.center {
	text-align: center;
}
.left {
	text-align: left;
}
.right {
	text-align: right;
}

.outerBox {
	padding: 0 20px;
}
.innerBox {
	border: 1px solid #eeeeee;
	border-radius: 5px;
	background-color: white;
	padding: 5vw;
	box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.15);
}
.paddingInnerInnerBox {
	padding: 10px 15px;
}
.outerBoxPass {
	padding: 20px;
}
.innerBoxPass {
	border: 1px solid #bdbdbd;
	border-radius: 5px;
	box-shadow: 10px 10px 20px #e0e0e0;
}
.paddingInnerInnerBox p {
	margin: 0;
}
.subPartTitle {
	font-size: 110%;
	padding: 6px 12px;
	color: #757575;
}
.collapsed:hover {
	text-decoration: underline;
}
.collapseButton {
	color: black;
}
</style>
